export default __webpack_public_path__ + "static/media/maybank-logo-vector.8f3c9563.svg";